import React, { useState } from "react";
import { Paragraph } from "@tipzty/tipzty-react-lib";
import { Col, Divider, Drawer, Row } from "antd";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/images/logo-large.png";
import { DASHBOARD_ROUTE } from "../shared/routes";
import { useMedia } from "react-use";
import { IS_TABLET } from "../shared/constants";
import { MenuOutlined } from "@ant-design/icons";

const TopBar = styled.div`
  width: 100%;
  height: 121px;
  background: transparent linear-gradient(180deg, #000000 0%, #ffffff00 100%) 0%
    0% no-repeat padding-box;
  padding: 24px;
`;

const Logo = styled.img`
  width: 74px;
  height: 79px;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    opacity: 0.75;
  }
`;

const Container = styled.div`
  height: 100vh;
  background-image: url("images/main-bg.png");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 24px;
  }
`;

const Menu = styled.ul`
  list-style: none;
`;

const MenuItem = styled.li`
  display: inline-block;
  margin-right: 24px;
  cursor: pointer;
  font-size: 16px;
  font-family: "Montserrat";
  transition: all 0.25s ease;

  &:hover {
    opacity: 0.75;
  }

  @media screen and (max-width: 768px) {
    display: block;
    margin-bottom: 24px;
  }
`;

const ButtonPrimary = styled.button`
  width: 100%;
  height: 52px;
  background: transparent linear-gradient(180deg, #d9c04d 0%, #f6dd67 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  opacity: 1;
  text-align: center;
  font: normal normal 600 18px/22px Montserrat;
  letter-spacing: 0px;
  color: #494949;
  opacity: 1;
  border: 0;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    background: transparent linear-gradient(180deg, #f6dd67 0%, #d9c04d 100%) 0%
      0% no-repeat padding-box;
  }
`;

const TextShadow = styled.p`
  text-align: left;
  font: normal normal bold 24px/29px Montserrat;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #0000004d;
  opacity: 1;
`;

const ButtonBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 32px;
`;

const Footer = styled.div`
  padding: 56px 0px;
  background: #fff;

  ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
  }

  li {
    text-align: left;
    font: normal normal normal 16px/19px Montserrat;
    letter-spacing: 0px;
    color: #494949;
    margin-bottom: 8px;
    cursor: pointer;

    a {
      color: #494949;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 24px;
  }
`;

const LandingView = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const isTablet = useMedia(IS_TABLET);
  const history = useHistory();

  const menu = [
    {
      name: "About us",
    },
    {
      name: "Investments",
    },
    {
      name: "FAQ",
    },
    {
      name: "Contact",
    },
  ];

  return (
    <div>
      <Container>
        {isTablet ? (
          <Row>
            <MenuOutlined
              style={{ fontSize: 20 }}
              onClick={() => setShowDrawer(true)}
            />
          </Row>
        ) : (
          <TopBar>
            <Row justify="center" align="middle">
              <Col xs={24} sm={22} md={21} lg={20}>
                <Row align="middle" gutter={[24, 0]}>
                  <Col xs={2}>
                    <Logo src={logo} />
                  </Col>
                  <Col md={16} lg={14} xl={12}>
                    <Menu>
                      {menu.map((item, itemIndex) => (
                        <MenuItem>{item.name}</MenuItem>
                      ))}
                    </Menu>
                  </Col>
                  <Col md={0} lg={8} xl={6}>
                    <ButtonPrimary
                      onClick={() => history.push(DASHBOARD_ROUTE)}
                    >
                      READY TO INVEST?
                    </ButtonPrimary>
                  </Col>
                  <Col md={0} lg={0} xl={4}>
                    <a href="mailto:info@wealthclubcapital.com">
                      <Paragraph size="14px" family="Montserrat" color="#fff">
                        info@wealthclubcapital.com
                      </Paragraph>
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </TopBar>
        )}
        <Row
          justify="center"
          align="middle"
          style={{ paddingTop: 48, flexDirection: "column" }}
        >
          <TextShadow>No Banks • No Brokers • No Middleman Fees</TextShadow>
          <TextShadow style={{ fontSize: 32, marginTop: 16 }}>
            START TODAY IN REAL ESTATE
          </TextShadow>
          {isTablet && (
            <ButtonPrimary
              onClick={() => history.push(DASHBOARD_ROUTE)}
              style={{ width: isTablet ? "70%" : 250 }}
            >
              READY TO INVEST?
            </ButtonPrimary>
          )}
        </Row>
        {!isTablet && (
          <ButtonBottom>
            <ButtonPrimary
              onClick={() => history.push(DASHBOARD_ROUTE)}
              style={{ width: isTablet ? "70%" : 250 }}
            >
              READY TO INVEST?
            </ButtonPrimary>
          </ButtonBottom>
        )}
      </Container>
      <Footer>
        <Row justify="center">
          <Col xs={24} md={20}>
            <Row gutter={[0, 24]}>
              <Col xs={24} md={6}>
                <Logo src={logo} />
              </Col>
              <Col xs={24} md={6}>
                <Paragraph
                  size="16px"
                  color="#494949"
                  family="Montserrat"
                  weight="bold"
                  marginBottom="8px"
                >
                  Legal
                </Paragraph>
                <ul>
                  <li>
                    <a href="https://wealthclub.pro/terms-and-conditions">
                      Terms and Conditions
                    </a>
                  </li>
                  <li>
                    <a href="https://wealthclub.pro/privacy-policy">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://wealthclub.pro/faq">FAQ</a>
                  </li>
                </ul>
              </Col>
              <Col xs={24} md={12}>
                <Paragraph size="10px" color="#848484" family="Montserrat">
                  *As of December 31, 2021. Investing involves risk, including
                  loss of principal. Past performance does not guarantee or
                  indicate future results. Any historical returns, expected
                  returns, or probability projections may not reflect actual
                  future performance. While the data we use from third parties
                  is believed to be reliable, we cannot ensure the accuracy or
                  completeness of data provided by investors or other third
                  parties. Neither Wealth Club Capital nor any of its affiliates
                  provide tax advice and do not represent in any manner that the
                  outcomes described herein will result in any particular tax
                  consequence. Offers to sell, or solicitations of offers to
                  buy, any security can only be made through official offering
                  documents that contain important information about investment
                  objectives, risks, fees and expenses. Prospective investors
                  should consult with a tax or legal adviser before making any
                  investment decision. For our current Regulation A offering(s),
                  no sale may be made to you in this offering if the aggregate
                  purchase price you pay is more than 10% of the greater of your
                  annual income or net worth . Different rules apply to
                  accredited investors and non-natural persons. For general
                  information on investing, we encourage you to refer to
                  www.investor.gov. For additional important risks, disclosures,
                  and information, please visit wealthclubcapital.com/disclosure
                </Paragraph>
              </Col>
            </Row>
          </Col>
          <Col xs={24}>
            <Paragraph
              color="#848484"
              family="Montserrat"
              textAlign="center"
              marginTop="48px"
            >
              All rights reserved © 2021 Wealthclub Capital
            </Paragraph>
          </Col>
        </Row>
      </Footer>
      <Drawer
        visible={showDrawer}
        placement="left"
        onClose={() => setShowDrawer(false)}
      >
        <Row justify="center">
          <Logo src={logo} />
        </Row>
        <Divider />
        <Menu>
          {menu.map((item, itemIndex) => (
            <MenuItem>{item.name}</MenuItem>
          ))}
        </Menu>
      </Drawer>
    </div>
  );
};

export default LandingView;
